import axios from 'axios';

const PortalPhysicalDevelopment= {
    namespaced: true,
    actions: {
        CreatePhysicalDevelopment({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalPhysicalDevelopment/CreatePhysicalDevelopment`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreatePhysicalDevelopmentMidTerm({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalPhysicalDevelopment/CreatePhysicalDevelopmentMidTerm`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetStudentForPhysicalDevelopment({ rootState }, { SectionId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalPhysicalDevelopment/GetStudentForPhysicalDevelopment?SectionId=${SectionId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetStudentForPhysicalDevelopmentMidTerm({ rootState }, { SectionId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalPhysicalDevelopment/GetStudentForPhysicalDevelopmentMidTerm?SectionId=${SectionId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },      

    }
}

export default PortalPhysicalDevelopment